import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowRight, Check, Play } from "lucide-react";
import { API, Shell, useT } from "./Shell";
import "./testTheme.css";

export default function TestTopics() {
  const navigate = useNavigate();
  const T = useT();
  const [data, setData] = useState(null);

  useEffect(() => {
    const studentId = localStorage.getItem("pjp-student");
    if (!studentId) { navigate("/physics-test"); return; }
    axios.get(`${API}/test/topics`, { params: { student_id: studentId } })
      .then(({ data: d }) => setData(d))
      .catch(() => setData({ topics: [], published: false }));
  }, [navigate]);

  return (
    <Shell>
      <div className="tp-wrap">
        <section className="tp-hero" style={{ paddingBottom: 10 }}>
          <a href="/portal" data-testid="tp-back-portal" style={{ display: "inline-block", marginBottom: 14, color: "inherit", opacity: 0.8, textDecoration: "none", fontSize: 14 }}>{T.tp_back_portal}</a>
          <div className="tp-eyebrow">{T.l_eyebrow}</div>
          <h1 data-testid="tp-topics-title">{T.tp_title}</h1>
          <p className="tp-sub">{T.tp_sub}</p>
        </section>
        <section className="tp-section" style={{ paddingTop: 6 }}>
          <div className="tp-eyebrow" style={{ marginBottom: 14 }} data-testid="tp-master-label">{T.tp_master}</div>
          {!data && <p className="tp-muted">{T.tp_loading}</p>}
          {data && data.topics.length === 0 && <div className="tp-panel" style={{ textAlign: "center" }} data-testid="tp-topics-empty"><p className="tp-muted">{T.tp_none}</p></div>}
          <div className="tp-cards" data-testid="tp-topics">
            {data?.topics.map((topic, i) => {
              const attempt = topic.attempt;
              const done = attempt?.status === "submitted";
              const resuming = attempt?.status === "in_progress";
              return (
                <div className="tp-card tp-topic-card" key={topic.topic_id} data-testid={`tp-topic-card-${i}`}>
                  <h3>{topic.name}</h3>
                  {topic.description && <p>{topic.description}</p>}
                  <p className="tp-note" style={{ margin: "6px 0 12px" }}>{T.tp_q_count(topic.questions)}</p>
                  {done && (
                    <>
                      <span className="tp-pill ok" data-testid={`tp-topic-done-${i}`}><Check size={13} /> {T.tp_done} · {T.tp_score_line(attempt.result.score, attempt.result.max_score)}</span>
                      <a className="tp-btn ghost small" style={{ marginTop: 12 }} href={`/physics-test/result/${attempt.attempt_id}`} data-testid={`tp-topic-result-${i}`}>{T.tp_view_result}</a>
                    </>
                  )}
                  {resuming && <a className="tp-btn small" style={{ marginTop: 12 }} href={`/physics-test/take/${topic.topic_id}`} data-testid={`tp-topic-resume-${i}`}><Play size={14} /> {T.tp_resume}</a>}
                  {!done && !resuming && topic.available && (
                    <button className="tp-btn small" style={{ marginTop: 12 }} onClick={() => navigate(`/physics-test/take/${topic.topic_id}`)} data-testid={`tp-select-${topic.topic_id}`}>{T.tp_select} <ArrowRight size={14} /></button>
                  )}
                  {!done && !resuming && !topic.available && <p className="tp-note" style={{ color: "#b54708", marginTop: 12 }} data-testid={`tp-topic-unavailable-${i}`}>{T.tp_unavailable} <span style={{ opacity: 0.75 }}>({T.tp_needs})</span></p>}
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </Shell>
  );
}
